
import MiscRepo from "@lib/api/server-side/misc.repo"
import SchoolRepo from "@lib/api/server-side/school.repo"
import ProgramLandingPage, { ProgramLandingPageProps } from "@modules/program/BootcampLandingPage"
import { GetServerSideProps } from "next"

export const getServerSideProps: GetServerSideProps<ProgramLandingPageProps> = async (ctx) => {
  const { slug } = ctx.params
  const res = ctx.res
  const repo = new SchoolRepo()
  const misc  = new MiscRepo()

  const convertToReviewFormat = (testimonies: any) => {
    const reviews = []

    if (!testimonies) {
      return reviews
    }

    for (let i = 0; i < testimonies.length; i++) {
      const testimony = testimonies[i]

      if (testimony !== null) {
        const review = {
          "@type": "Review",
          name: testimony?.testimony_username,
          reviewBody: testimony?.testimony,
          reviewRating: {
            "@type": "Rating",
            ratingValue: testimony?.testimony_rating,
            bestRating: "5",
            worstRating: "1",
          },
          datePublished: testimony?.date_published,
          author: {
            "@type": "Person",
            name: testimony?.testimony_username,
          },
          publisher: {
            "@type": "Organization",
            name: testimony?.company?.company_name,
            logo: {
              "@type": "ImageObject",
              url: testimony?.company?.company_picture,
            },
          },
        }

        reviews.push(review)
      }
    }

    return reviews
  }

  try {
    const userAgent = ctx.req.headers["user-agent"]
    const response =  repo.schoolDetailV2(slug as string, userAgent)
    const response2 =  repo.videoTestimonies(userAgent)
    const response3 = misc.getBannerInfo(userAgent)
    let videoTestimonies = []

    const [schoolDetail, vt, bnr] = await Promise.all([response, response2, response3])

    if (schoolDetail.statusCode !== 200) {
      return {
        notFound: true,
      }
    }

    if(vt.statusCode === 200){
      const videoResult = JSON.parse(vt.body).result
      if(videoResult){
        videoTestimonies = videoResult
      }
    }

    const body = JSON.parse(schoolDetail.body)

    const result = body.result

    if (typeof result === "string") {
      return {
        notFound: true,
      }
    }

    const schema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: result?.product_name,
      image: result?.school_banner?.banner_image,
      description: result?.school_meta_description,
      brand: {
        "@type": "Brand",
        name: "Harisenin.com",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: result?.review_rating?.rating_value,
        bestRating: 5,
        worstRating: 1,
        ratingCount: result?.review_rating?.rating_count,
        reviewCount: result?.review_rating?.rating_count,
      },
      review: convertToReviewFormat(result?.school_testimonies),
    }

    const videoPreviews = result?.school_video_previews ?? []

    const videoSchemas = videoPreviews.map((preview) => {
      return {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name: preview.video_title,
        description: preview.video_description,
        thumbnailUrl: preview.video_thumbnail,
        uploadDate: result.school_created_at,
        contentUrl: preview.video_link,
        embedUrl: preview.video_link,
        duration: "PT5M0S", //di api tidak ada
        potentialAction: {
          "@type": "SeekToAction",
          target: preview.video_link + "&t={seek_to_second_number}",
          "startOffset-input": "required name=seek_to_second_number",
        },
      }
    })
    
    if (!result) {
      return {
        notFound: true,
      }
    } else {
      return {
        props: {
          schoolDetail: result,
          schema,
          videoSchemas,
          videoTestimonies
        },
      }
    }
  } catch (e) {
    console.log({ e })
    res.setHeader("Location", "/")
    res.statusCode = 301

    return {
      notFound: true,
    }
  }
}

export default ProgramLandingPage
